import script from "./UserRoleModal.vue?vue&type=script&setup=true&lang=js"
export * from "./UserRoleModal.vue?vue&type=script&setup=true&lang=js"

import "./UserRoleModal.vue?vue&type=style&index=0&id=469775ba&lang=scss&scoped=true"
script.__scopeId = "data-v-469775ba"

export default script